var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitedError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.267 32.337a3.967 3.967 0 110 7.934 3.967 3.967 0 010-7.934zm-3.372-19.142h6.813v8.183l-1.872 9.396h-3.042l-1.899-9.396v-8.183z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D9DFE4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8 52.6C13.551 52.6 2 41.049 2 26.8S13.551 1 27.8 1c7.896 0 15.207 3.57 20.075 9.593A25.691 25.691 0 0153.6 26.8c0 14.249-11.551 25.8-25.8 25.8zm0-1.6C41.165 51 52 40.165 52 26.8a24.092 24.092 0 00-5.369-15.201A24.148 24.148 0 0027.8 2.6C14.435 2.6 3.6 13.435 3.6 26.8 3.6 40.165 14.435 51 27.8 51z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitedError);
export default __webpack_public_path__ + "static/media/Invited_error.f1da6a0fc3128a06e92cfc57b94c1e62.svg";
export { ForwardRef as ReactComponent };